import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ba769ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "keypad_height",
  class: "wapper-main"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_the_warning = _resolveComponent("the-warning")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (_ctx.isWarning)
      ? (_openBlock(), _createBlock(_component_the_warning, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}